var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.715 11.068c-.548-.313-1.253-.313-1.88 0l-4.386 2.585-2.977 1.645-4.308 2.584c-.549.314-1.254.314-1.88 0l-3.369-2.036a1.91 1.91 0 0 1-.94-1.645v-3.915c0-.627.314-1.254.94-1.645L8.285 6.68c.548-.312 1.253-.312 1.88.001l3.368 2.038c.548.313.94.94.94 1.645v2.585l2.976-1.724V8.561c0-.625-.314-1.252-.94-1.644l-6.267-3.68c-.548-.314-1.253-.314-1.88 0L1.94 6.994c-.627.313-.94.94-.94 1.566v7.364c0 .627.313 1.253.94 1.645l6.345 3.68c.548.314 1.253.314 1.88 0l4.308-2.506 2.976-1.723 4.307-2.506c.549-.313 1.253-.313 1.88 0l3.368 1.959c.549.313.94.94.94 1.645v3.916c0 .627-.313 1.253-.94 1.645l-3.29 1.957c-.548.313-1.253.313-1.88 0l-3.368-1.958a1.91 1.91 0 0 1-.94-1.646v-2.507l-2.976 1.724v2.586c0 .626.314 1.253.94 1.644l6.346 3.682c.548.313 1.253.313 1.88 0l6.344-3.682c.548-.313.94-.94.94-1.644v-7.442c0-.626-.313-1.253-.94-1.645l-6.345-3.682z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatic);
export default __webpack_public_path__ + "static/media/MATIC.f4c1d2379a862ae3fb30cc4f214ec435.svg";
export { ForwardRef as ReactComponent };